import React, {Component} from 'react';
import moment from "moment";


import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faFastForward, faSpinner, faCheck, faExclamation} from '@fortawesome/free-solid-svg-icons'

library.add(faFastForward, faSpinner, faCheck, faExclamation)


export default class DispatchListItem extends Component {


    render() {
        const order = this.props.data;


        if (!order) {
            return null;
        }


        const highlighted = this.isHighlighted(this.props.scheduled, order);

        const disabled = this.isDisabled(this.props.scheduled, order);

        const failure = order.dispatchStatus === 'failure';

        const pending = this.isWaitingResponse(this.props.scheduled, order);

        const actionIcon = (pending ? "spinner" : ( failure ? "exclamation": (disabled ? "check" : "fast-forward")));

        const itemStyle = (failure ? "dispatch-list-item dispatch-list-item-failure" : disabled ? "dispatch-list-item dispatch-list-item-disabled" : (highlighted  ? "dispatch-list-item-highlighted" : "dispatch-list-item"))
        const actionClass = (pending ? "dispatch-list-item-action-spinning" : "dispatch-list-item-action");


        const dispatchTimeFormated = moment(order.deliveryDate).format("HH:mm");

        return (
            <div className={itemStyle}>
                <div className="dispatch-list-item-address">{order.address}</div>
                <div className="dispatch-list-item-time">{dispatchTimeFormated}</div>
                <div className={actionClass}
                     onClick={(event) => {
                         if (pending || disabled) return;
                         this.props.onClickAction(order, event)
                     }}
                >
                    <FontAwesomeIcon icon={actionIcon}/>
                </div>
            </div>
        );
    }


    isHighlighted(scheduled, order) {
        let result = false;
        if (scheduled.highlighted.id === order.id) {
            result = true;
            return result;
        }
        return result;
    }


    isDisabled(scheduled, order) {
        let result = false;
        scheduled.status.dispatched.forEach(value => {
            if (value === order.id) {
                result = true;
                return result;
            }
        })

        return result;
    }


    isWaitingResponse(scheduled, order) {
        if (!scheduled.action.pending) {
            return false;
        }


        let result = false;
 
        if (scheduled.id && scheduled.id === order.id) {
            result = true;
        }
        if (scheduled === order.id) {
            result = true;
        }


        return result;
    }


}
